import { render, staticRenderFns } from "./TableOfContent.vue?vue&type=template&id=61ba3e33&"
import script from "./TableOfContent.vue?vue&type=script&lang=js&"
export * from "./TableOfContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports